// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__30Wcm","title":"InfoRow_title__r4odc"};